import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

function ProspectingNavIcon({ kind }) {
  if (kind === 'map') return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m3 6 6-3 6 3 6-3v15l-6 3-6-3-6 3z" />
      <path d="M9 3v15M15 6v15" />
    </svg>
  );
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M8 6h13M8 12h13M8 18h13" />
      <path d="M3.5 6h.01M3.5 12h.01M3.5 18h.01" strokeWidth="3" />
    </svg>
  );
}

/** Stała pionowa nawigacja drugiego poziomu, obok głównego menu Xonite ONE. */
export default function ProspectingLayout() {
  const location = useLocation();
  const links = [
    { to: '/prospecting/lista', label: 'Lista handlowca', icon: 'list' },
    { to: '/prospecting/mapa', label: 'Mapa rynku', icon: 'map' },
  ];
  return (
    <div className="prospecting-shell">
      <nav className="prospecting-local-nav" aria-label="Widoki ONE Prospecting">
        {links.map(item => (
          <NavLink key={item.to} to={item.to} end={item.to === '/prospecting/mapa'}
            title={item.label} aria-label={item.label}
            className={({ isActive }) => `prospecting-local-nav-link${isActive || (item.to === '/prospecting/mapa' && location.pathname === '/prospecting') ? ' is-active' : ''}`}>
            <ProspectingNavIcon kind={item.icon} />
            <span className="prospecting-sr-only">{item.label}</span>
          </NavLink>
        ))}
      </nav>
      <main className="prospecting-content" id="prospecting-content"><Outlet /></main>
    </div>
  );
}
